export const getLocationSources = (state = [], action) => {
    switch(action.type){
        case 'GET_LOCATION_SOURCES':
            return{
                ...state,
                sources: action.payload,
                loading: false
            }
        case 'EDIT_LOCATION_SOURCE':
            const {id, key, new_value} = action.payload;
            return{
                ...state,
                sources: {
                    ...state.sources,
                    data: state?.sources?.data?.map(item =>
                        item.source.id == id
                        ? { 
                            ...item,
                            url: new_value,
                            source: {
                                ...item.source,
                                [key]: new_value
                            }
                          }
                        : item
                    )
                }
            }
        case "DELETE_LOCATION_SOURCE":
            return {
                ...state,
                sources: {
                    ...state.sources,
                    data: state?.sources?.data?.filter(item => item.source.id != action.payload)
                }
            }
        case 'LOADING_TABLES':
            return{
                ...state,
                loading: true
            }
        case 'CLEAR_LOADING_TABLES':
            return{
                ...state,
                loading: false,
            }
        case 'CLEAR_SOURCES':
            return{
                ...state,
                sources: undefined,
            }
        default:
            return{
                ...state
            }
    }
}

export const getLocationAvaliableSources = (state = [], action) => {
    switch(action.type){
        case 'GET_LOCATION_AVALIABLE_SOURCES':
            return{
                ...state,
                sources: action.payload,
            }
        default:
            return{
                ...state
            }
    }
}